var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.adminInfo && _vm.$store.state.adminInfo.id)?_c('div',{staticClass:"admin-box"},[_c('NavHeaderComponent'),_vm._v(" "),_c('NavMenuComponent',[_c('template',{slot:"content"},[_c('router-view')],1)],2)],1):_vm._e(),_vm._v(" "),(_vm.$store.state.adminInfo && !_vm.$store.state.adminInfo.id)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08323418","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 